import i18next from 'i18next';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {ApolloProvider} from 'react-apollo';
import initApollo from '../initApollo';
import {AuthRoute} from '../../login/containers/Auth';
import {ROLES} from '../../common/constants';
import Admin from '../../admin/Admin';
import Login from '../../login/containers/Login';
import Register from '../../login/containers/Register';
import ForgotPass from '../../login/containers/ForgotPassword';
import ResetPass from '../../login/containers/ResetPassword';
import ActivateUser from '../../login/components/ActivateUser';
import ConfirmUser from '../../login/components/ConfirmUser';
import Public from '../../public/Public';
import NotFoundPage from '../../public/common/NotFoundPage';
import {I18nextProvider} from 'react-i18next';
import React from 'react';
import initTranslations from '../initTranslations';
import '../../common/global.scss';
import StripeProvider from './StripeProvider';

initTranslations();

const App = () => (
  <StripeProvider>
    <I18nextProvider i18n={i18next}>
      <BrowserRouter>
        <ApolloProvider client={initApollo()}>
          <Switch>
            <AuthRoute path="/admin" roles={Object.values(ROLES)} component={Admin} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/forgot-password" component={ForgotPass} />
            <Route exact path="/reset-password/:token" component={ResetPass} />
            <Route exact path="/activation/:token" component={ActivateUser} />
            <Route exact path="/confirmation/:token" component={ConfirmUser} />
            <Route path="/" component={Public} />
            <Route path="*" component={NotFoundPage} />
          </Switch>
        </ApolloProvider>
      </BrowserRouter>
    </I18nextProvider>
  </StripeProvider>
);

export default App;
